<!-- 下载内容弹窗 -->
<template>
  <lzd-modal
    form
    :width="1200"
    :title="toI18n('下载中心')"
    :append-to-body="true"
    v-model="visible"
    @opened="handleOpened"
    @closed="handleClosed"
  >
    <ele-pro-table
      ref="tableRef"
      row-key="seq"
      :columns="columns"
      :datasource="datasource"
      :tools="false"
      v-model:selections="selections"
      :cache-key="
        LzdUtil.buildTableCacheKey('userDownloadAsyncExportTaskTable')
      "
    >
      <template #action="{ row }">
        <el-link
          :underline="false"
          :icon="DownloadOutlined"
          :type="row.percent === 100 ? 'primary' : 'info'"
          @click="handleDownload(row)"
        />
      </template>
    </ele-pro-table>
    <template #footer>
      <el-button type="primary" @click="reload()" :icon="ReloadOutlined">
        {{ toI18n('刷新') }}
      </el-button>
      <el-button @click="handleCancel" :icon="CloseOutlined">{{
        toI18n('关闭')
      }}</el-button>
    </template>
  </lzd-modal>
</template>

<script lang="ts" setup>
  import { ref } from 'vue';
  import { toI18n } from '@/api/bsl/system/i18n';
  import {
    CloseOutlined,
    DownloadOutlined,
    ReloadOutlined
  } from '@/components/icons';
  import LzdUtil from '@/utils/lzd-util';
  import { asyncExportTaskApi } from '@/api/bsl/system/async-export-task';
  import type { AsyncExportTask } from '@/api/bsl/system/async-export-task/types';
  import type { EleProTableInstance } from 'ele-admin-plus/es/ele-app/plus';
  import type {
    DatasourceFunction,
    Where
  } from 'ele-admin-plus/es/ele-pro-table/types';

  const visible = defineModel({ type: Boolean });
  const tableRef = ref<EleProTableInstance>(null);
  const selections = ref<AsyncExportTask[]>([]);
  const current = ref<AsyncExportTask>();
  const columns = LzdUtil.i18nColumns([
    {
      type: 'selection',
      columnKey: 'selection',
      width: 50,
      align: 'center',
      fixed: 'left'
    },
    {
      label: '',
      type: 'index',
      columnKey: 'index',
      width: 70,
      align: 'center',
      fixed: 'left'
    },
    {
      columnKey: 'action',
      slot: 'action',
      label: toI18n('操作'),
      width: 60,
      align: 'center',
      fixed: 'right'
    },
    {
      prop: 'taskName',
      label: toI18n('任务名称'),
      minWidth: 450
    },
    {
      prop: 'percent',
      label: toI18n('进度'),
      align: 'right',
      width: 90,
      formatter: (row) => `${row.percent ?? 0} %`
    },
    {
      prop: 'createdAt',
      label: toI18n('创建时间'),
      width: 180
    }
  ]);

  const datasource: DatasourceFunction = ({ pages, where, orders }) => {
    const wheres = LzdUtil.buildWhereLike({ ...where }, 'taskId', 'taskName');
    return asyncExportTaskApi.queryPage({
      where: wheres,
      ...orders,
      ...pages
    });
  };

  /** 搜索 */
  const reload = (where?: Where, page?: number) => {
    selections.value = [];
    tableRef.value?.reload?.({ page, where });
  };

  const handleCancel = () => {
    visible.value = false;
  };

  const handleClosed = () => {};
  const handleOpened = () => {
    reload();
  };

  const handleDownload = (row: AsyncExportTask) => {
    asyncExportTaskApi.downloadFile(row);
  };
</script>
